enum PinLegendDataLevel {
  ORGANIZATION = "org",
  USER = "user",
}

export default PinLegendDataLevel;
